import { render, staticRenderFns } from "./Open.vue?vue&type=template&id=dc1cbe1a&scoped=true&"
import script from "./Open.vue?vue&type=script&lang=js&"
export * from "./Open.vue?vue&type=script&lang=js&"
import style0 from "./Open.vue?vue&type=style&index=0&id=dc1cbe1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1cbe1a",
  null
  
)

export default component.exports